import { all, fork } from "redux-saga/effects";

import * as contentSagas from "./content";

export default function* rootSaga() {
    yield all(
        [...Object.values(contentSagas)].map(fork)
    );
}